import { mapGetters, mapActions } from 'vuex'
import Utils from '@/utils/default'

export default store => ({
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      collection: `${store}/collection`,
      pages: `${store}/pages`
    }),
    pageKey () {
      return this.generatePageKey(this.filter)
    },
    currentPage () {
      return this.pages[this.pageKey] || {}
    },
    [store.split('/').reverse()[0]] () {
      return (this.currentPage.list || [])
        .map(id => this.collection[id])
    },
    pagination () {
      return this.currentPage.pagination || {}
    }
  },
  watch: {
    filter (newValue, oldValue) {
      const codedNewValue = JSON.stringify(this.generatePageKey(newValue))
      const codedOldValue = JSON.stringify(this.generatePageKey(oldValue))
      if (codedNewValue === codedOldValue) { return }
      this.fetchPage()
    }
  },
  methods: {
    ...mapActions({
      _fetchPage: `${store}/fetchPerPage`
    }),
    generatePageKey (filter) {
      const query = filter || { page: this.page }
      return Utils.dataToUrlString(query)
    },
    fetchPage () {
      this.loading = true
      this._fetchPage(this.filter)
        .then(_ => {
          if (this.urlParams) {
            this.$router.push({
              ...this.$route,
              query: Utils.dataForUrl(this.urlParams(this.filter))
            })
          }
        })
        .then(_ => this.$emit('filterUpdated', this.filter))
        .then(_ => (this.loading = false))
        .catch(_ => (this.loading = false))
    },
    changePage (page) {
      this.filter = { ...this.filter, page }
    }
  },
  mounted () {
    this.fetchPage(this.filter)
  }
})



// WEBPACK FOOTER //
// ./src/mixins/pagination.js